import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import OCRActions, { ocrActionTypes } from '@Actions/ocrActions';
import TrackerActions from '@Actions/trackerActions';
import OCRService from '@Services/ocrServices';

/**
 * @param action
 */
function* _uploadDocumentOCR(action) {
  try {
    yield put(OCRActions.uploadDocumentOCRLoading(true));
    const { payload } = action;
    const ocrData = yield OCRService.uploadDocumentOCR(payload);
    if (!ocrData.success) {
      notification.open({
        type: 'error',
        message: ocrData?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(ocrActionTypes.UPLOAD_DOCUMENT_OCR.SUCCESS, {
        request: action?.payload,
        response: ocrData,
      }));
      notification.open({
        type: 'success',
        message: 'Document uploaded successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(ocrData);
      }
    }
    yield put(OCRActions.uploadDocumentOCRLoading(false));
  } catch (error) {
    yield put(OCRActions.uploadDocumentOCRLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(ocrActionTypes.UPLOAD_DOCUMENT_OCR.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* uploadDocumentOCR() {
  yield takeLatest(ocrActionTypes.UPLOAD_DOCUMENT_OCR.REQUEST, _uploadDocumentOCR);
}

/**
 *
 */
export default function* ocrSaga() {
  yield all([uploadDocumentOCR(),]);
}